<template>
  <div>
    <ProjectItem>
      <ProjectTitle title="健康指南"></ProjectTitle>
      <div class="zn-item" v-for="(item, index) in guides" :key="index">
        <ItemDetail :item="item"></ItemDetail>
        <div v-if="index != total - 1" class="item-divider"></div>
      </div>
    </ProjectItem>
  </div>
</template>

<script>
import ProjectItem from "../../item.vue";
import ProjectTitle from "../../title.vue";
import ItemDetail from "./item.vue";
export default {
  components: {
    ProjectItem,
    ProjectTitle,
    ItemDetail,
  },
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
    guides() {
      return (this.ReportData || {}).guides || [];
    },
    total() {
      return this.guides.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.zn-item {
  padding: 10px;
  .item-divider {
    margin: 20px 0;
    height: 1px;
    background: #ccc;
  }
}
</style>